/**
 * @generated SignedSource<<b560cbe60d280828bd15be2892d07b97>>
 * @relayHash b6071d1c2e53bdf61c08f5cff42d350d
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/564.0.0-2026-06-17T18:34:14.300Z/SbSharedRefineMenuTypeaheadContainerQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuTypeaheadContainerQuery$variables = {
  facetName?: string | null;
  hasQuery?: boolean | null;
  searchString?: string | null;
  uriRef?: string | null;
  userCountryCode?: string | null;
};
export type SbSharedRefineMenuTypeaheadContainerQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"SbSharedRefineMenuTypeaheadContainer_viewer">;
  };
};
export type SbSharedRefineMenuTypeaheadContainerQuery = {
  response: SbSharedRefineMenuTypeaheadContainerQuery$data;
  variables: SbSharedRefineMenuTypeaheadContainerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "facetName"
  },
  {
    "defaultValue": false,
    "kind": "LocalArgument",
    "name": "hasQuery"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "searchString"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "uriRef"
  },
  {
    "defaultValue": "",
    "kind": "LocalArgument",
    "name": "userCountryCode"
  }
],
v1 = {
  "kind": "Variable",
  "name": "facetName",
  "variableName": "facetName"
},
v2 = {
  "kind": "Variable",
  "name": "searchString",
  "variableName": "searchString"
},
v3 = {
  "kind": "Variable",
  "name": "uriRef",
  "variableName": "uriRef"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SbSharedRefineMenuTypeaheadContainerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": [
              (v1/*: any*/),
              {
                "kind": "Variable",
                "name": "hasQuery",
                "variableName": "hasQuery"
              },
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "kind": "Variable",
                "name": "userCountryCode",
                "variableName": "userCountryCode"
              }
            ],
            "kind": "FragmentSpread",
            "name": "SbSharedRefineMenuTypeaheadContainer_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SbSharedRefineMenuTypeaheadContainerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "condition": "hasQuery",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "countryCode",
                    "variableName": "userCountryCode"
                  },
                  (v1/*: any*/),
                  (v2/*: any*/),
                  (v3/*: any*/)
                ],
                "concreteType": "ItemFacetsQueryConnection",
                "kind": "LinkedField",
                "name": "itemFacetSearch",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemFacetsQueryEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FilterValueType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "urlLabel",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "linkReference",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "displayName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "count",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-finding/564.0.0-2026-06-17T18:34:14.300Z/SbSharedRefineMenuTypeaheadContainerQuery",
    "metadata": {},
    "name": "SbSharedRefineMenuTypeaheadContainerQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "7952cd030cfb60c3982097c317e6df24";

export default node;
